import {fetchGet, fetchPost, fetchPatch} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const getVenueUserEmail = (
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/user/email",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const getVenueEdit = (
    venueId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/edit",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const updateVenueById = (
    venueId,
    venueUpdate,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    const params = venueUpdate;
    fetchPatch(
        uri + "/venue/" + venueId + "/update",
        successMethod,
        errorMethod,
        params,
        getAccessTokenSilently);
};

export const deleteFromVenueById = (
    venueId,
    venueDelete,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    const params = venueDelete;
    fetchPost(
        uri + "/venue/" + venueId + "/delete",
        successMethod,
        errorMethod,
        params,
        getAccessTokenSilently);
};

export const addToVenueById = (
    venueId,
    venueAdd,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    const params = venueAdd;
    fetchPost(
        uri + "/venue/" + venueId + "/add",
        successMethod,
        errorMethod,
        params,
        getAccessTokenSilently);
};